import * as React from 'react';
import { IResultCountProps } from './result-count.types';



const ResultCount: React.FC<IResultCountProps> = ({ totalResults, currentPageResults, pageSize, currentPage, isLoading, searchTerm, numberOfResultsText }) => {
    const getResultsText = () => {
        let resultsText: string;

        const rangeFirst = ((currentPage - 1) * pageSize) + 1;
        const rangeLast = totalResults < pageSize ? totalResults : rangeFirst + currentPageResults - 1;
        const rangeStr = (rangeFirst == rangeLast) ? rangeFirst.toString() : `${rangeFirst.toString()} - ${rangeLast.toString()}`;
        resultsText = numberOfResultsText
            .replace("{{resultsShown}}", rangeStr)
            .replace("{{totalResults}}", totalResults.toString())
            .replace("{{searchTerm}}", searchTerm);

        return resultsText;
    }

    return (
        <>
            {!isLoading && totalResults > 0 &&
                <h2 className="search-results-subheading" dangerouslySetInnerHTML={{ __html: getResultsText() }}>
                </h2>
            }
        </>
    );
}

export default ResultCount;